import React from 'react';
import { navigate as windowNavigate } from '@telia-front/window';
export const RouterContext = React.createContext({
    navigate: windowNavigate,
});
